import Vue from 'vue'
const state = {
  currentShowSeries: {}
}

const mutations = {
  setCurrentShowSeries: (state, payload) => {
    if (payload.series) {
      state.currentShowSeries = payload.series
    }
  },
  setNewMemberNumber: (state, payload) => {
    state.currentShowSeries.members.forEach(m => {
      if (m.id === payload.member_id) {
        m.membership_number = payload.membership_number
      }
    })
  },
  addSponsor_series: (state, payload) => {
    state.currentShowSeries.sponsors.push(payload)
  },
  updateSeriesMember: (state, member) => {
    state.currentShowSeries.members.forEach((m, i) => {
      if (m.id === member.id) {
        Vue.set(state.currentShowSeries.members, i, member)
      }
    })
  },
  admin_updateSanctioningForm: (state, form) => {
    state.currentShowSeries.sanctioning_forms.forEach((f, i) => {
      if (f.id === form.id) {
        Vue.set(state.currentShowSeries.sanctioning_forms, i, form)
      }
    })
  }
}

const actions = {
  // Event Actions
  loadCurrentShowSeries: ({commit, rootState}, payload) => {
    return rootState.apiInstance.get(`/callFunction/showSeriesHome?series_slug=${payload.slug}`)
      .then(response => {
        commit('setCurrentShowSeries', {series: response.data.data})
      })
  },
  addSanctioningForm: ({commit, rootState}, payload) => {
    payload.name = 'series_sanctioning'
    return rootState.apiInstance.post('/data/seriesSanctioningForm', payload)
      .then((resp) => {
        payload.id = resp.data.data.id
        commit('userDataAddData', payload)
      })
  },
  updateSanctioningForm: ({commit, rootState}, payload) => {
    return rootState.apiInstance.put(`/data/seriesSanctioningForm/${payload.id}`, payload)
      .then(() => {
        commit('userData_updateSanctioningForm', payload)
      })
  },
  deleteSanctioningForm: ({commit, rootState}, payload) => {
    return rootState.apiInstance.delete(`/data/seriesSanctioningForm/${payload.id}`)
      .then(() => {
        commit('userData_removeSanctioningForm', payload)
      })
      .catch(() => {
        // console.log(error)
      })
  },
  adminUpdateSanctioningForm: ({commit, rootState}, payload) => {
    return rootState.apiInstance.put(`/data/seriesSanctioningForm/${payload.id}`, payload)
      .then(() => {
        commit('admin_updateSanctioningForm', payload)
      })
  },
  addSeriesMember: ({commit, rootState}, payload) => {
    let member = {...payload.member}
    member.show_series_id = payload.show_series_id
    member.membership_number = 0
    member.membership_status = payload.cost ? 'PENDING' : 'ACTIVE'
    member.date_joined = payload.cost ? null : new Date()
    // FIX THIS BUG...
    return rootState.apiInstance.get(`getNextMemberNumber?show_series_id=${member.show_series_id}&skip=${payload.cost !== 0}`)
      .then(response => {
        member.membership_number = response.data.data
        return rootState.apiInstance.post('/data/showSeriesMembers', member)
          .then(response => {
            member.name = 'show_series_membership'
            member.add_ons = []
            member.animal_nominations = []
            member.id = response.data.data.id
            commit('userDataAddData', member)
          })
          .catch(() => {
            // console.log(error)
          })
      })
  },
  updateSeriesMember: ({commit, rootState}, member) => {
    return rootState.apiInstance.put(`/data/showSeriesMembers/${member.id}`, member)
      .then(() => {
        commit('updateSeriesMember', member)
      })
  },
  deleteSeriesMember: ({commit, rootState}, payload) => {
    return rootState.apiInstance.delete(`/data/showSeriesMembers/${payload.id}`)
      .then(response => {
        commit('userData_removeMember', payload)
      })
      .catch(() => {
        // console.log(error)
      })
  },
  addMembershipAddOn: ({commit, rootState}, payload) => {
    let addOn = JSON.parse(JSON.stringify(payload))
    // console.log(addOn)
    return rootState.apiInstance.post('/data/membershipAddOn', addOn)
      .then(response => {
        // payload.name = 'show_series_addon'
        addOn.show_series_member_add_on_id = response.data.data.show_series_member_add_on_id
        commit('userDataAddData_addon', addOn)
      })
      .catch(() => {
        // console.log(error)
      })
  },
  deleteMembershipAddOn: ({commit, rootState}, payload) => {
    return rootState.apiInstance.delete(`/data/membershipAddOn/${payload.show_series_member_add_on_id}`)
      .then(response => {
        commit('userData_removeAddon', payload)
      })
      .catch(() => {
        // console.log(error)
      })
  },
  addAnimalNomination: ({commit, rootState, dispatch}, payload) => {
    let nomination = JSON.parse(JSON.stringify(payload))
    nomination.created_by = '1234'
    return rootState.apiInstance.post('/data/showSeriesAnimalNomination', nomination)
      .then(response => {
        // payload.name = 'show_series_addon'
        nomination.show_series_animal_nomination_id = response.data.data.show_series_animal_nomination_id
        commit('userDataAddData_animalNomination', nomination)
        dispatch('saveAnimal', {exhibitor_id: nomination.exhibitor_id, animal: nomination.animal, entry_ids: [], nomination_id: response.data.data.show_series_animal_nomination_id})
      })
      .catch(() => {
        // console.log(error)
      })
  },
  editAnimalNomination: ({commit, rootState, dispatch}, payload) => {
    let nomination = JSON.parse(JSON.stringify(payload))
    return rootState.apiInstance.put(`/data/showSeriesAnimalNomination/${nomination.show_series_animal_nomination_id}`, nomination)
      .then(response => {
        commit('userDataUpdateData_animalNomination', nomination)
        dispatch('saveAnimal', {exhibitor_id: nomination.exhibitor_id, animal: nomination.animal, entry_ids: [], nomination_id: nomination.show_series_animal_nomination_id})
      })
  },
  deleteAnimalNomination: ({commit, rootState}, payload) => {
    return rootState.apiInstance.delete(`/data/showSeriesAnimalNomination/${payload.show_series_animal_nomination_id}`)
      .then(response => {
        if (!payload.isAdmin) {
          commit('userData_removeAnimalNomination', payload)
        }
      })
      .catch(() => {
        // console.log(error)
      })
  },
  adminPushThroughMembership: ({commit, rootState}, payload) => {
    return rootState.apiInstance.post('/updateMemberPaid', payload)
      .then(response => {
        commit('setNewMemberNumber', {
          member_id: payload.member_id,
          membership_number: response.data.data.number
        })
      })
  },
  adminPushThroughAnimalNomination: ({commit, rootState, dispatch}, payload) => {
    return rootState.apiInstance.put(`/data/showSeriesAnimalNomination/${payload.show_series_animal_nomination_id}`, {status: 'PAID'})
      .then(response => {
        if (payload.member.membership_number === 0) {
          dispatch('adminPushThroughMembership', payload.member)
        }
      })
  },
  adminPushThroughAddOn: ({commit, rootState, dispatch}, payload) => {
    return rootState.apiInstance.put(`/data/membershipAddOn/${payload.show_series_member_add_on_id}`, {status: 'PAID'})
      .then(response => {
        if (payload.member.membership_number === 0) {
          dispatch('adminPushThroughMembership', payload.member)
        }
      })
  },
  saveSponsor_series: ({rootState, state, commit, getters}, sponsor) => {
    if (sponsor.sponsor_id) {
      sponsor.last_updated_by = getters.getUserID
      return rootState.apiInstance.put(`/data/sponsors/${sponsor.sponsor_id}`, sponsor)
    } else {
      sponsor.created_by = getters.getUserID
      return rootState.apiInstance.post('/data/sponsors', sponsor)
        .then(result => {
          sponsor.sponsor_id = result.data.data.sponsor_id
          commit('addSponsor_series', sponsor)
        })
    }
  }
}

const getters = {
  mySeriesMembers: (state, getters, rootState) => {
    if (state.currentShowSeries && rootState.user) {
      return rootState.userData.show_series_membership.filter(member => member.show_series_id === state.currentShowSeries.show_series_id)
        .map(member => {
          member.exhibitor = rootState.userData.exhibitors.filter(e => e.exhibitor_id === member.exhibitor_id)[0]
          return member
        })
    } else {
      return []
    }
  },
  myShowSeriesSanctioning: (state, getters, rootState) => {
    if (state.currentShowSeries && rootState.user) {
      return rootState.userData.series_sanctioning.filter(sanctioning => sanctioning.show_series_id === state.currentShowSeries.show_series_id)
    } else {
      return []
    }
  }
}

export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters
}
